import { render, staticRenderFns } from "./practise.vue?vue&type=template&id=49fc8abe&scoped=true"
import script from "./practise.vue?vue&type=script&lang=js"
export * from "./practise.vue?vue&type=script&lang=js"
import style0 from "./practise.vue?vue&type=style&index=0&id=49fc8abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fc8abe",
  null
  
)

export default component.exports